import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';

export const CoreBasicApiService = Symbol('CoreBasicApiService');

export type CoreBasicApiService = PsHttpService

export interface ApiCopilotFeedbackRequest {
    type: 'LIKE' | 'DISLIKE';
    query: string;
    content: string;
    intent: string;
    product: string;
}

export interface ApiCopilotFeedbackResponse {
    success: boolean;
}

export const ApiCopilotFeedback = Symbol('ApiCopilotFeedback');

export interface ApiCopilotFeedback {
    copilotFeedback(data: ApiCopilotFeedbackRequest): Promise<ApiCopilotFeedbackResponse>;
}


export interface ApiCopilotInitRequest {}

export interface ApiCopilotInitResponse {
    copilot_flag: boolean;
    copilot_limitation: number;
    copilot_usage: number;
    copilot_qaflag: boolean;
}

export const ApiCopilotInit = Symbol('ApiCopilotInit');

export interface ApiCopilotInit {
    copilotInit(data: ApiCopilotInitRequest): Promise<ApiCopilotInitResponse>;
}
